import { useState } from 'react'
import axios from 'axios'
import TransactionSupportRequiredDialog from '@/Pages/Transactions/TransactionSupportRequiredDialog'

export function useConfirmIfTransactionSupportRequired(transaction) {
  const [showDialog, setShowDialog] = useState(false)
  const [onConfirm, setOnConfirm] = useState(null)
  const [requirements, setRequirements] = useState(null)

  const checkAndConfirmTransactionSupportRequirement = async (data, confirmedCallback) => {
    const endpoint = route('api.transactions.check-transaction-support', transaction)
    const response = await axios.post(endpoint, data)
    const requirements = response.data?.requirements || []

    if (requirements.length > 0) {
      setOnConfirm(() => () => confirmedCallback())
      setShowDialog(true)
      setRequirements(requirements)
    } else {
      confirmedCallback()
    }
  }

  const confirm = () => {
    onConfirm?.()
    setShowDialog(false)
  }

  const cancel = () => {
    setShowDialog(false)
  }

  const TransactionSupportRequiredConfirmationDialog = () => (
    <TransactionSupportRequiredDialog
      transaction={transaction}
      requirements={requirements}
      shouldOpen={showDialog}
      onSuccess={confirm}
      onClosed={cancel}
    />
  )

  return {
    checkAndConfirmTransactionSupportRequirement,
    TransactionSupportRequiredConfirmationDialog,
  }
}
